import request from '@/utils/request'
// 获取证书数据
export default async function getCertificate (assetId) {
    return await request.get(`/api/yyzContract/appHuayilianPc?asset_id=${assetId}`)
}